module.exports = __webpack_public_path__ + "media/rhythm_from_ancient_times.28cbb159.mp3";